export function phoneToHref(phone) {
  if (!phone) return '';

  const cleaned = phone.replace(/[^+\d]/g, '');
  return 'tel:' + cleaned;
}

export function getDomain(url) {
  if (!url) return '';

  try {
    // The URL constructor ensures proper parsing
    let hostname = new URL(url).hostname;
    return hostname.replace(/^www\./, ''); // Remove www. if present
  } catch (e) {
    // If input is not a valid URL, fallback to manual extraction
    let match = url.match(/^(?:https?:\/\/)?(?:www\.)?([^\/:?#]+)/i);
    return match ? match[1] : '';
  }
}
